import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    HiOutlineHome,
    HiOutlineBriefcase,
    HiOutlineSearch,
    HiOutlineChatAlt2,
    HiOutlineCog,
    HiOutlineBell,
    HiOutlineLocationMarker,
    HiX,
    HiOutlineFilter,
    HiPlus
} from "react-icons/hi";

// Mock Data for Creators
const mockCreators = [
    {
        id: 1,
        name: "Creator Name",
        username: "UserName",
        niche: "Fashion",
        age: 22,
        location: "Hyderabad, In.",
        avatarColor: "bg-indigo-200"
    },
    {
        id: 2,
        name: "Creator Name",
        username: "UserName",
        niche: "Fashion",
        age: 22,
        location: "Hyderabad, In.",
        avatarColor: "bg-blue-200"
    },
    {
        id: 3,
        name: "Creator Name",
        username: "UserName",
        niche: "Fashion",
        age: 22,
        location: "Hyderabad, In.",
        avatarColor: "bg-teal-200"
    },
    {
        id: 4,
        name: "Creator Name",
        username: "UserName",
        niche: "Fashion",
        age: 22,
        location: "Hyderabad, In.",
        avatarColor: "bg-yellow-200"
    },
    {
        id: 5,
        name: "Creator Name",
        username: "UserName",
        niche: "Fashion",
        age: 22,
        location: "Hyderabad, In.",
        avatarColor: "bg-pink-200"
    },
    {
        id: 6,
        name: "Creator Name",
        username: "UserName",
        niche: "Fashion",
        age: 22,
        location: "Hyderabad, In.",
        avatarColor: "bg-sky-200"
    }
];


const FindCreators = () => {
    const navigate = useNavigate();
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    return (
        <div className="flex h-screen bg-[#FDFBF7]">
            {/* Sidebar */}
            <aside className="w-64 bg-white border-r border-gray-100 flex flex-col hidden md:flex">
                <div className="p-6 flex items-center gap-2 text-black font-bold text-xl">
                    <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                    <span>Braccet</span>
                </div>

                <nav className="flex-1 px-4 py-6 space-y-2">
                    <NavItem to="/brand/dashboard" icon={<HiOutlineHome />} label="Overview" />
                    <NavItem to="/brand/campaigns" icon={<HiOutlineBriefcase />} label="Campaigns" />
                    <NavItem to="/brand/search" icon={<HiOutlineSearch />} label="Find Creators" active />
                    <NavItem to="/brand/messages" icon={<HiOutlineChatAlt2 />} label="Messages" />
                    <NavItem to="/brand/settings" icon={<HiOutlineCog />} label="Settings" />
                </nav>

                <div className="p-4 border-t border-gray-100">
                    <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-gray-50 cursor-pointer">
                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold">
                            B
                        </div>
                        <div>
                            <p className="text-sm font-bold text-gray-900">Brand Name</p>
                            <p className="text-xs text-gray-500">brand@example.com</p>
                        </div>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-1 overflow-hidden flex flex-col h-screen">
                <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 px-6 py-3 flex justify-between items-center shrink-0">
                    <h1 className="text-2xl font-bold text-gray-900">Find Creators</h1>
                    <div className="flex items-center gap-4">
                        <button className="p-2 text-gray-400 hover:text-gray-600 relative">
                            <HiOutlineBell className="text-xl" />
                            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
                        </button>
                        <button
                            className="bg-[#0044CC] text-white px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 hover:bg-blue-700 transition-colors"
                            onClick={() => window.location.href = '/brand/create-campaign'}
                        >
                            <HiPlus className="text-lg" />
                            Create Campaign
                        </button>
                    </div>
                </header>

                {/* Content Container */}
                <div className="flex-1 overflow-y-auto p-8">
                    <div className="max-w-6xl mx-auto space-y-8">
                        
                        {/* Search Bar */}
                        <div className="flex gap-4 items-center bg-[#EBF5FF] rounded-2xl p-2 px-6">
                            <input 
                                type="text" 
                                placeholder="Search an influencer/creator/UGC"
                                className="flex-1 bg-transparent border-none focus:outline-none text-gray-700 placeholder-gray-400 py-3"
                            />
                            <button className="text-gray-500 hover:text-gray-900 transition-colors">
                                <HiOutlineSearch className="text-2xl" />
                            </button>
                            <button 
                                onClick={() => setIsFilterOpen(true)}
                                className="text-gray-500 hover:text-gray-900 transition-colors border-l border-blue-200 pl-4 ml-2"
                            >
                                <HiOutlineFilter className="text-2xl" />
                            </button>
                        </div>

                        {/* Creator Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {mockCreators.map(creator => (
                                <CreatorCard 
                                    key={creator.id} 
                                    creator={creator} 
                                    onClick={() => navigate(`/brand/creators/${creator.id}`)}
                                />
                            ))}
                        </div>

                    </div>
                </div>

                {/* Filter Modal Overlay */}
                {isFilterOpen && (
                    <div className="absolute inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-3xl p-8 max-w-2xl w-full shadow-2xl relative animate-fadeIn">
                            
                            {/* Close Button */}
                            <button 
                                onClick={() => setIsFilterOpen(false)}
                                className="absolute -top-3 -right-3 w-8 h-8 bg-[#0044CC] text-white rounded-full flex items-center justify-center hover:bg-blue-700 shadow-md"
                            >
                                <HiX />
                            </button>

                            <h2 className="text-2xl font-bold text-gray-900 mb-8">Filter</h2>
                            
                            <div className="grid grid-cols-2 gap-x-8 gap-y-6">
                                {/* Creator Search */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700">Creator</label>
                                    <input 
                                        type="text" 
                                        placeholder="Search by Name / User Name"
                                        className="w-full bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                    />
                                </div>

                                {/* Gender Select */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700">Gender</label>
                                    <div className="relative">
                                        <select className="w-full bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none text-sm text-gray-500">
                                            <option>Choose a Gender</option>
                                            <option>Female</option>
                                            <option>Male</option>
                                            <option>Any</option>
                                        </select>
                                        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                                            <i className="fa-solid fa-chevron-down text-xs"></i>
                                        </div>
                                    </div>
                                </div>

                                {/* Niche Select */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700">Niche</label>
                                    <div className="relative">
                                        <select className="w-full bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none text-sm text-gray-500">
                                            <option>Search by Niche</option>
                                            <option>Fashion</option>
                                            <option>Beauty</option>
                                            <option>Travel</option>
                                        </select>
                                        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                                            <i className="fa-solid fa-chevron-down text-xs"></i>
                                        </div>
                                    </div>
                                </div>

                                {/* Location Select */}
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-gray-700">Location</label>
                                    <div className="relative">
                                        <select className="w-full bg-gray-50 border border-gray-100 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none text-sm text-gray-500">
                                            <option>Search by Location</option>
                                            <option>Hyderabad, In.</option>
                                            <option>Mumbai, In.</option>
                                            <option>Delhi, In.</option>
                                        </select>
                                        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                                            <i className="fa-solid fa-chevron-down text-xs"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="flex justify-end gap-4 mt-10">
                                <button 
                                    onClick={() => setIsFilterOpen(false)}
                                    className="px-8 py-3 bg-gray-200 text-gray-700 font-bold rounded-2xl hover:bg-gray-300 transition-colors"
                                >
                                    Clear
                                </button>
                                <button 
                                    onClick={() => setIsFilterOpen(false)}
                                    className="px-10 py-3 bg-[#0044CC] text-white font-bold rounded-2xl hover:bg-blue-700 transition-colors"
                                >
                                    Apply
                                </button>
                            </div>
                            
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
};

// Sub-components
const CreatorCard = ({ creator, onClick }) => (
    <div className="bg-white rounded-[2rem] p-6 shadow-sm border border-gray-50 flex flex-col items-center">
        <div className="w-full flex justify-between items-start mb-6">
            <div className="flex flex-col">
                <span className="font-bold text-gray-900 text-lg">{creator.name}</span>
                <span className="text-sm text-gray-400 font-medium">{creator.username}</span>
            </div>
        </div>

        <div className={`w-36 h-36 ${creator.avatarColor} rounded-full mb-6`}></div>

        <div className="bg-[#EBF5FF] text-[#0044CC] px-6 py-1.5 rounded-full text-sm font-semibold mb-6">
            {creator.niche}
        </div>

        <div className="flex items-center gap-2 text-sm font-bold text-gray-800 mb-6">
            <span>{creator.age}yrs</span>
            <span className="text-gray-300">-</span>
            <HiOutlineLocationMarker className="text-gray-500" />
            <span>{creator.location}</span>
        </div>

        <button 
            onClick={onClick}
            className="w-full bg-black text-white font-bold py-3.5 rounded-xl hover:bg-gray-800 transition-colors"
        >
            View
        </button>
    </div>
);

const NavItem = ({ to, icon, label, active }) => (
    <Link to={to} className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${active ? 'bg-blue-50 text-[#0044CC]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}>
        <span className="text-xl">{icon}</span>
        {label}
    </Link>
);


export default FindCreators;
